import { render } from "./Tablet.vue?vue&type=template&id=61acaeca&scoped=true"
import script from "./Tablet.vue?vue&type=script&lang=js"
export * from "./Tablet.vue?vue&type=script&lang=js"

import "./Tablet.vue?vue&type=style&index=0&id=61acaeca&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61acaeca"]])

export default __exports__